// Excel export issue with cellRender prop
/*import React from 'react'
import { CellWarning } from 'components/DxDataTable/styled'

const cellRender = ({ data, text }) => data?.isCancelled ? <CellWarning>{text}</CellWarning> : text*/

import { Loading, PDFSymbol } from 'media/icons'
import React from 'react'
import numberFormatter from 'helpers/numberFormatter'

export const getBillCols = ({ t, locales, handlePdfClick, pdfsLoading }) => [
	{
		caption: t('common.fields.date'),
		dataField: 'dateTime',
		searchable: false,
		width: 'auto',
		localFormat: {
			type: 'date'
		}
		// cellRender
	}, {
		caption: t('common.fields.time'),
		dataField: 'dateTime',
		allowSearch: false,
		width: 'auto',
		localFormat: { type: 'time' }
		// cellRender
	}, {
		caption: t('closing_section.strings.bill_pdf'),
		allowSearch: false,
		cellRender: (row) => {
			const billNumber = Number(row?.data?.number)
			const billDate = row?.data?.dateTime
			const cashRegisterId = row?.data?.cashRegisterId
			if(pdfsLoading[billNumber]) {
				return <Loading />
			}
			return (
				<PDFSymbol
					style={{ display: 'block', width: '21px', height: '21px' }}
					onClick={handlePdfClick({ billNumber, cashRegisterId, billDate })}
				/>
			)
		},
		width: 'auto'
	}, {
		caption: t('common.fields.cash_register'),
		dataField: 'cashRegisterName',
		// cellRender,
		width: 'auto'
	}, {
		caption: t('statistic_section.strings.bill_number'),
		dataField: 'number',
		width: 70
		// cellRender
	}, {
		caption: t('statistic_section.strings.user_name'),
		dataField: 'userName'
		// cellRender
	}, {
		caption: t('statistic_section.strings.cancellation'),
		dataField: 'isCancelled',
		dataType: 'boolean',
		showEditorAlways: false,
		trueText: t('common.strings.canceled'),
		falseText: t('common.strings.not_canceled')
		// cellRender
	}, {
		caption: t('common.fields.total'),
		dataField: 'total',
		width: 'auto',
		localFormat: {
			type: 'float'
		},
		summary: {
			calculateCustomSummary: options => {
				const { name, summaryProcess, value } = options
				if(name === 'totalWithoutCanceled') {
					if(summaryProcess === 'start') {
						options.totalValue = 0
					}
					if(!value?.isCancelled) {
						options.totalValue = options.totalValue + (value?.total || 0)
					}
				}
			},
			column: null,
			showInColumn: 'total',
			summaryType: 'custom',
			name: 'totalWithoutCanceled'
		}
		// cellRender
	}
]

const StrickOutCellOnDelFlag = ({ displayValue, data: { flag } }) => (
	flag === 'Deleted' ?
		<div style={{ textDecoration: 'line-through' }}>{displayValue}</div> :
		displayValue
)

export const getBillItemCols = ({ t, locales }) => [
	{
		caption: t('common.fields.quantity'),
		dataField: 'amount',
		width: 'auto',
		localFormat: { type: 'float', precision: 3, floatsPrecisionOnly: true },
		cellRender: (rowState) => !Number(rowState?.displayValue) ? null : StrickOutCellOnDelFlag(rowState)
	}, {
		caption: t('common.fields.code'),
		dataField: 'product.code',
		width: 80,
		cellRender: StrickOutCellOnDelFlag
	}, {
		caption: t('common.fields.name'),
		dataField: 'product.name',
		calculateDisplayValue: ({ product, flag, mul1 }) => {
			const cellValue = product?.name
			if(cellValue) {
				return cellValue
			}
			switch(flag) {
				case 'TotalAmount':
					return t('common.fields.total')
				case 'TotalInEuro':
					return `${t('closing_section.strings.billitem_given')} (€ ${numberFormatter(mul1, { locale: locales, toFixed: 2 })}) `
				case 'Retour':
					return t('statistic_section.strings.return')
				case 'TotalInCHF':
					return t('statistic_section.strings.given')
				case 'Tips':
					return t('statistic_section.strings.tips')
				default:
					return flag || ''
			}
		},
		cellRender: StrickOutCellOnDelFlag
	}, {
		id: 'price',
		caption: t('common.fields.amount'),
		dataField: 'price',
		width: 'auto',
		localFormat: { type: 'float' },
		calculateDisplayValue: ({ flag, price }) => flag === 'zero' ? price.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		cellRender: StrickOutCellOnDelFlag
	}, {
		caption: '%',
		dataField: 'discountPercent',
		width: 60,
		calculateDisplayValue: ({ discountPercent }) => discountPercent ? `${discountPercent}%` : '',
		cellRender: StrickOutCellOnDelFlag
	}, {
		caption: t('common.strings.vat'),
		dataField: 'codeMWSt',
		calculateDisplayValue: ({ codeMWSt }) => {
			switch(codeMWSt) {
				case 'free':
					return t('closing_section.fields.vat_free')
				case 'normal':
					return t('closing_section.fields.vat_normal')
				case 'reduced':
					return t('closing_section.fields.vat_reduced')
				case 'special':
					return t('closing_section.fields.vat_special')
				default:
					return codeMWSt || ''
			}
		},
		cellRender: StrickOutCellOnDelFlag
	}, {
		caption: t('statistic_section.strings.in_cafe'),
		dataField: 'inCafe',
		calculateDisplayValue: ({ flag, inCafe }) => flag === 'zero' ? inCafe : true,
		cellRender: StrickOutCellOnDelFlag
	}, {
		id: 'total',
		caption: t('common.fields.total'),
		dataField: 'total',
		width: 60,
		localFormat: { type: 'float' },
		calculateDisplayValue: ({ total }) => total.toLocaleString(locales, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}),
		cellRender: StrickOutCellOnDelFlag
	}
]
